import React, { PropTypes } from 'react';
import B from 'bem-cn';

import './index.scss';
import Tabs, { Tab } from '../tabs';
import { scrollToElement } from '../../utils/scroll';
import getStaticContent from '../../utils/getStaticContent';

const cl = B('Careers');

export default class Careers extends React.Component {
  constructor(props) {
    super(props);

    this.staticContent = getStaticContent('careers', props.currentPageName);

    this.tabItems = this.staticContent.tabs.map(item => item.title);
    this.state = {
      tabIdx: 0
    };
  }

  static propTypes = {
    passRef: React.PropTypes.func,
    currentPageName: PropTypes.string.isRequired
  };

  shouldComponentUpdate(nextProps, nextState) {
    if (nextState !== this.state) {
      return true;
    }
    return false;
  }

  onTabChange() {
    scrollToElement('#careers');
  }

  render() {
    return (
      <div className={cl} id="careers" ref={this.props.passRef}>
        <div className="container">
          <div className={cl('title')}>{this.staticContent.title}</div>
          <Tabs index={this.state.tabIdx} onChange={this.onTabChange}>
            {this.staticContent.tabs.map((item, itemIndex) => (
              <Tab key={itemIndex} label={item.title}>
                <div dangerouslySetInnerHTML={{ __html: item.content }} />
              </Tab>
            ))}
          </Tabs>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ../src/components/careers/index.jsx